export default "__VITE_ASSET__54b282bf__"